import React,{Component} from 'react';
import Select from 'react-select';

import { Input, Label, FormGroup, Row, Col, Card, CardBody, FormText } from 'reactstrap';

import get from 'lodash/get';
import find from 'lodash/find';
import capitalize from 'lodash/capitalize'

import EngagementChoiceInputContainer from './EngagementChoiceInputContainer';
import HiddenInput from '../../../shared/components/HiddenInput';

import {
  titleForEngagement,
  countsToRoundedPercents,
  typeOfContraints,
  formatEngagementKind,
  formatStatus
} from '../../../shared/utils';


function formatCampaignLabel(data){
  const campaign = data.campaign;
  return (
    <div>
      <span className='DropdownOptionSubtitle'>{formatStatus(campaign.status).toUpperCase()}</span><br />
      {campaign.name}
    </div>
  )
}

function formatEngagementLabel(data){
  const engagement = data.engagement;
  return (
    <div>
      <span className='DropdownOptionSubtitle'>{formatEngagementKind(engagement.kind).toUpperCase()}</span><br />
      {titleForEngagement(engagement)}
    </div>
  )
}

class EngagementResponseInput extends Component {
  constructor(){
    super();

    this.state = {
      selectedCampaignId:null,
      selectedEngagementId:null,
      selectedResponses:[],
      selectedCampaignOption:null,
      selectedEngagementOption:null
    }
  }

  componentWillReceiveProps(nextProps){
    const { selectedCampaignId } = this.state
    if(selectedCampaignId && !nextProps.campaigns.some(c => c.id === selectedCampaignId) ){
      this.setState({selectedCampaignId: null, selectedEngagementId: null, selectedEngagementOption: null, selectedResponses: [], selectedCampaignOption: null});
    }
  }

  componentDidMount(){
    const { defaultValue, campaigns } = this.props;

    if(typeOfContraints(defaultValue).name === 'response'){
      let responses = [],
        selectedCampaign,
        selectedEngagement;

      defaultValue.forEach((constraint) => {
        selectedCampaign = find(campaigns,(c) => c.id === constraint.requiredCampaignId);

        if(selectedCampaign){
          selectedEngagement = find(this.props.engagements,(e) => e.id === constraint.engagementId);
          responses.push(constraint.value);
        }
      });

      if(selectedCampaign && selectedEngagement && responses.length > 0){
        this.setState({
          selectedCampaignId:selectedCampaign.id,
          selectedEngagementId:selectedEngagement.id,
          selectedCampaignOption:{
            campaign:selectedCampaign,
            label:`${capitalize(selectedCampaign.status)} - ${selectedCampaign.name}`,
            value:selectedCampaign.id
          },
          selectedEngagementOption:{
            engagement:selectedEngagement,
            label:`${formatEngagementKind(selectedEngagement.kind)} - ${titleForEngagement(selectedEngagement)}`,
            value:selectedEngagement.id
          },
          selectedResponses:responses
        })
      }
    }
  }

  handleCampaignChange(e){
    this.setState({
      selectedCampaignOption:e,
      selectedCampaignId:e.value,
      selectedEngagementId:null,
      selectedEngagementOption:null,
      selectedResponses:[]
    });

    this.props.onCampaignChange(e.value);
    this.props.onChange();
  }

  handleEngagmentChange(e){
    this.setState({
      selectedEngagementOption:e,
      selectedEngagementId:e.value,
      selectedResponses:[]
    });

    this.props.onEngagementChange(e.value);
    this.props.onChange();
  }

  render(){
    const { campaigns, campaignKpis, warning } = this.props;

    const {
      selectedCampaignId,
      selectedEngagementId,
      selectedResponse,
      selectedCampaignOption,
      selectedEngagementOption,
      selectedResponses
    } = this.state;

    const selectedCampaign = find(campaigns,(c) => c.id === selectedCampaignId),
        selectedEngagements = selectedCampaign ? this.props.engagements.filter((e) => e.campaignId === selectedCampaign.id) : [],
      selectedEngagement = selectedCampaign ? find(this.props.engagements,(e) => e.id === selectedEngagementId) : null,
      campaignKPI = find(campaignKpis,(c) => c.campaignId === selectedCampaignId),
      engagementKPI = find(get(campaignKPI,['engagementKPIs'],[]),(e) => e.engagementId === selectedEngagementId),
      answerKPIs = engagementKPI ? engagementKPI.answerKPIs : [],
      fudgedAnswerPercents = countsToRoundedPercents(answerKPIs.map((k) => k.answersNum)),
      fudgedAnswerKPIS = answerKPIs.map((a,i) => ({...answerKPIs[i],percent:fudgedAnswerPercents[i]}))

    function getOptionResults(optionId){
      const answer = find(fudgedAnswerKPIS,(a) => a.answer === optionId);
      return answer ? (
        <span>
            &nbsp;&nbsp;
            <strong>{answer.percent}%</strong>
            &nbsp;&nbsp;
            <strong>{answer.answersNum}</strong>
        </span>
      ) : <span>&nbsp;&nbsp; Loading...</span>
    }

    return (
      <div>
        <Select
          className='SubtitledReactSelectContainer'
          classNamePrefix='SubtitledReactSelect'
          value={selectedCampaignOption}
          options={campaigns.map((c) => ({
            campaign:c,
            label:`${capitalize(c.status)} - ${c.name}`,
            value:c.id
          }))}
          isSearchable={false}
          placeholder='Select experience...'
          formatOptionLabel={(arg) => formatCampaignLabel(arg)}
          onChange={(e) => this.handleCampaignChange(e)}
        />
        {selectedCampaign && (
          <div key={selectedCampaign.id}>
            <HiddenInput name='responseCampaignId' value={selectedCampaignId} />
            <br />
            <Select
              className='SubtitledReactSelectContainer'
              classNamePrefix='SubtitledReactSelect'
              value={selectedEngagementOption}
              options={selectedEngagements.filter(e => e.kind !== 'puzzle').map((e) => ({
                engagement:e,
                label:`${formatEngagementKind(e.kind)} - ${titleForEngagement(e)}`,
                value:e.id
              }))}
              isSearchable={false}
              placeholder='Select activity...'
              formatOptionLabel={(arg) => formatEngagementLabel(arg)}
              onChange={(e) => this.handleEngagmentChange(e)}
            />
            {selectedEngagement && (
              <div key={selectedEngagement.id}>
                <HiddenInput name='responseEngagementId' value={selectedEngagementId} />
                <br />
                {selectedEngagement.kind === 'this_or_that' && (
                  <EngagementChoiceInputContainer>
                    <Row>
                      <Col xs='6'>
                        <img
                          className='EngagementResponseGraphic'
                          src={selectedEngagement.firstImageURL}
                          alt='this choice graphic'
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <FormGroup
                          check
                          className='EngagementResponseGraphicFormGroup'
                        >
                          <Label check>
                            <Input
                              type='radio'
                              name='answer'
                              value='0'
                              defaultChecked={selectedResponses.indexOf('0') >= 0}
                            />
                            {selectedEngagement.firstImageTitle}
                            {getOptionResults('0')}
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col xs='6'>
                        <img
                          className='EngagementResponseGraphic'
                          src={selectedEngagement.secondImageURL}
                          alt='that choice graphic'
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <FormGroup
                          check
                          className='EngagementResponseGraphicFormGroup'
                        >
                          <Label check>
                            <Input
                              type='radio'
                              name='answer'
                              value='1'
                              defaultChecked={selectedResponses.indexOf('1') >= 0}
                            />
                            {selectedEngagement.secondImageTitle}
                            {getOptionResults('1')}
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                  </EngagementChoiceInputContainer>
                )}
                {(selectedEngagement.kind === 'qa' || selectedEngagement.kind === 'choose')&& (
                  <EngagementChoiceInputContainer>
                    <Row>
                      <Col xs='2'>
                        <img
                          className='EngagementResponseGraphic'
                          src={selectedEngagement.firstImageURL}
                          alt='first image graphic'
                        />
                      </Col>
                      <Col xs='5'>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type='checkbox'
                              name={`multipleAnswer[${selectedEngagement.options[0].id}]`}
                              defaultChecked={selectedResponses.indexOf(selectedEngagement.options[0].id) >=0}
                            />
                            {selectedEngagement.options[0].answer}
                            {getOptionResults(selectedEngagement.options[0].id)}
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type='checkbox'
                              name={`multipleAnswer[${selectedEngagement.options[1].id}]`}
                              defaultChecked={selectedResponses.indexOf(selectedEngagement.options[1].id) >=0}
                            />
                            {selectedEngagement.options[1].answer}
                            {getOptionResults(selectedEngagement.options[1].id)}
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col xs='5'>
                        {selectedEngagement.options.length > 2 && (
                          <FormGroup check>
                            <Label check>
                              <Input
                                type='checkbox'
                                name={`multipleAnswer[${selectedEngagement.options[2].id}]`}
                                defaultChecked={selectedResponses.indexOf(selectedEngagement.options[2].id) >=0}
                              />
                              {selectedEngagement.options[2].answer}
                              {getOptionResults(selectedEngagement.options[2].id)}
                            </Label>
                          </FormGroup>
                        )}
                        {selectedEngagement.options.length > 3 && (
                          <FormGroup check>
                            <Label check>
                              <Input
                                type='checkbox'
                                name={`multipleAnswer[${selectedEngagement.options[3].id}]`}
                                defaultChecked={selectedResponses.indexOf(selectedEngagement.options[3].id) >=0}
                              />
                              {selectedEngagement.options[3].answer}
                              {getOptionResults(selectedEngagement.options[3].id)}
                            </Label>
                          </FormGroup>
                        )}
                      </Col>
                    </Row>
                  </EngagementChoiceInputContainer>
                )}
                {selectedEngagement.kind === 'ratable' && (
                  <EngagementChoiceInputContainer>
                    <Row>
                      <Col xs='2'>
                        <video
                          autoPlay
                          loop
                          muted
                          className='EngagementResponseGraphic'
                        >
                          <source src={selectedEngagement.videoURL} />
                          Sorry, your browser does not support this type of video.
                        </video>
                      </Col>
                      <Col xs='5'>
                        <FormGroup check className='EngagementResponseGraphicFormGroup'>
                          <Label check>
                            <Input
                              type='radio'
                              name='answer'
                              value={1}
                              defaultChecked={selectedResponses.indexOf('1') >= 0}
                            />
                            Like
                            {getOptionResults('1')}
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col xs='5'>
                        <FormGroup check className='EngagementResponseGraphicFormGroup'>
                          <Label check>
                            <Input
                              type='radio'
                              name='answer'
                              value='0'
                              defaultChecked={selectedResponses.indexOf('0') >= 0}
                            />
                            Not for me
                            {getOptionResults('0')}
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                  </EngagementChoiceInputContainer>
                )}
              </div>
            )}
          </div>
        )}
        {warning.length > 0 && (
          <FormText className='DangerFeedback'>{warning}</FormText>
        )}
      </div>
    )
  }
}

EngagementResponseInput.defaultProps = {
  warning:''
};

export default EngagementResponseInput;




// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignAudience/components/EngagementResponseInput.js